import React from "react";
import Slider from "react-slick";
import {
  Box,
  Grid,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowForwardIos,
  ArrowBackIos,
  Grain,
  LocationOn,
  DesignServices,
  Security,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images
import friedonionbanner from './images/friedonionbanner.jpg';
import webdesign from './images/webdesign.jpg'
import webdevelopment from './images/webdev.png'
import logodesign from './images/logo desgin.jpg'
import digitalmarketing from './images/digitalmarketing.jpg'
import pinkOnionFlakeImage from './images/Dehydrated Onion Flakes Supplier, Exporter _ Dehydratedveg_com.jpeg'
import garlicCloveImage from './images/GarlicClove.jpg'
import garlicChoppedImage from './images/GarlicMinced.jpeg'
import garlicMincedImage from './images/how-to-mince-garlic-2171-1.jpg'
import garlicGranulesImage from './images/GarlicGranules.jpg'
import garlicpowderimg from './images/garlicpowder.jpg'
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp'
import pinkOnionChoppedImage from './images/purple-onion-cut-half-pink-strips-visible-against-dark-background-344354882.webp'
import pinkOnionMincedImage from './images/pinkonionminced.jpg'
import pinkOnionPowderImage from './images/pinkonionpowder.jpg'
import whiteOnionFlakeImage from './images/whiteonionflakes.webp'
import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg'
import whiteOnionChoppedImage from './images/dehydrated-white-onion-chopped-500x500.webp'
import whiteOnionMincedImage from './images/dehydrated-white-onion-minced-500x500.webp'
import whiteOnionPowderImage from './images/dehydrated-white-onion-powder.jpg'
import redOnionFlakeImage from './images/redonionflakes.webp'
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg'
import redOnionChoppedImage from './images/red-onion-chopped-2-scaled-500x500.webp'
import redOnionMincedImage from './images/dehydrated-red-onion-minced-500x500.webp'
import redOnionPowderImage from './images/redonionpowder.jpg'
import friedOnionFreshImage from './images/organic-onion-fried-500x500.webp'
import friedCoatedWhiteOnionImage from './images/whitecoatedonion.webp'
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg'
import friedWhiteOnionFlakeImage from './images/friedcoatedmin.jpg'
import friedPinkOnionFlakeImage from './images/friedonionbanner.jpg'
import gingerFlakeImage from './images/dehydrated-ginger-flakes.jpg'
import gingerPowderImage from './images/113563735.webp'
import greenChilliPowderImage from './images/dehydrated-green-chilli-powder-500x500.webp'
import tamarindPowderImage from './images/tamarind-powder-500x500.webp'
import tomatoPowderImage from './images/toamatopowder.jpg'
import mintPowderImage from './images/mint-leaves-pudina-patta-powder-2nd.jpeg'
import potatoPowderImage from './images/istockphoto-185902790-612x612.jpg'
import spinachPowderImage from './images/spinachpowder.jpg'
import mangoPowderImage from './images/AmchurPowder.webp'
import fenugreekPowderImage from './images/7d59b4210bfcc07bb28cdba3eae734816bdc8e06_1024x1024.webp'
import lemonPowderImage from './images/07_Spray-Dried-Lemon-Powder-600x600.jpg'
import beetrootPowderImage from './images/DriedBeetrootPowder.webp'
import cheesePowderImage from './images/IMG_6946_800x.webp'
import corianderPowderImage from './images/CorianderPowder.webp'
import beetrootImage from './images/istockphoto-493446908-612x612.jpg'
import cabbageImage from './images/istockphoto-544313316-612x612.jpg'
import carrotImage from './images/carrots.jpg'
import tomatoImage from './images/istockphoto-98026003-612x612.jpg'
import gingerImage from './images/istockphoto-162711007-612x612.jpg'
import potatoImage from './images/istockphoto-1346299887-612x612.jpg'
import greenChilliImage  from './images/green-chilli-200-g-product-images-o590000187-p590000187-0-202409251830.webp'

// Components
import Commonredirects from "./Commonredirects";
import FeatureProduct from "./FeatureProduct";

// Theme Colors
const primaryColor = "#1F473E";
const secondaryColor = "#D4C9B6";

// Animation
const floatAnimation = {
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <ArrowForwardIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      right: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const PrevArrow = ({ onClick }) => (
  <ArrowBackIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const DetailedFriedOnions = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      image: friedonionbanner,
     title: "Fried Onion Products",
description: "Enjoy the rich, savory crunch of our premium fried onions—expertly made from farm-fresh onions and perfectly crisped to elevate your meals with authentic taste and texture.",
 buttonText: "Order Now",
    },
  ];


const friedFreshOnion = {
  image: friedOnionFreshImage,
  features: [
    {
      icon: Grain,
      title: "Fresh Fried Onion",
      description:
        "Ready-to-eat crispy fried onions. Used for toppings in biryanis, burgers, and salads.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Sliced & Fried. Color: Golden brown. Flavor: Sweet, crunchy. Shelf Life: 6 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Made from fresh onions, thinly sliced and deep-fried to perfection. Retains flavor and crispiness.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Perfect garnish for biryani, kebabs, burgers, and Indo-fusion dishes.",
    },
  ],
};

const friedCoatedWhiteOnion = {
  image: friedCoatedWhiteOnionImage,
  features: [
    {
      icon: Grain,
      title: "Fried Coated White Onion",
      description:
        "Coated white onion for extra crunch. Crispy and savory – ideal for snack seasoning or garnish.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Coated & Fried. Color: Light golden. Coating: Flour-based. Shelf Life: 6 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Extra crunchy texture with mild onion sweetness. Popular in snacks and ready-to-eat mixes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Great for adding texture to street food, fast food, and packaged snacks.",
    },
  ],
};

const friedCoatedPinkOnion = {
  image: friedCoatedPinkOnionImage,
  features: [
    {
      icon: Grain,
      title: "Fried Coated Pink Onion",
      description:
        "Coated pink onion with extra crunch. Bold onion taste with crispy coating.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Coated & Fried. Color: Reddish golden. Flavor: Rich onion. Shelf Life: 6 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Prepared from premium pink onions, coated and fried for enhanced flavor and texture.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Commonly used in chaat, savory snacks, and packaged ready-to-eat meals.",
    },
  ],
};

const friedWhiteOnionFlake = {
  image: friedWhiteOnionFlakeImage,
  features: [
    {
      icon: Grain,
      title: "Fried White Onion Flakes",
      description:
        "Flaky fried white onions. Delicious topping for fast foods and Indian cuisine.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Flakes. Color: Light brown. Texture: Crispy. Shelf Life: 6 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Thin fried flakes made from white onions. Adds crunch and mild onion flavor.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Perfect for sprinkling over noodles, rice, and wraps for added crispiness.",
    },
  ],
};

const friedPinkOnionFlake = {
  image: friedPinkOnionFlakeImage,
  features: [
    {
      icon: Grain,
      title: "Fried Pink Onion Flakes",
      description:
        "Flaky fried pink onions. Adds rich onion flavor with crispy texture.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Flakes. Color: Reddish brown. Taste: Stronger onion punch. Shelf Life: 6 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Made from dehydrated pink onions, then lightly fried into crunchy flakes.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Excellent for Indian dishes, salads, and savory bakery fillings.",
    },
  ],
};





  return (
    <>
      {/* Hero Slider */}
      <Box sx={{ width: "100%", height: "90vh", overflow: "hidden", position: "relative" }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box
              key={index}
              sx={{
                height: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `url(${slide.image}) center/cover no-repeat`,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "rgba(31, 71, 62, 0.3)",
                  color: secondaryColor,
                  padding: "20%",
                  borderRadius: "10px",
                  textAlign: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h2" sx={{ fontFamily: "'Playfair Display', serif", fontWeight: "bold", mb: 2 }}>
                    {slide.title}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h5" sx={{ fontFamily: "'Playfair Display', serif", mb: 3 }}>
                    {slide.description}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: secondaryColor, color: primaryColor, fontWeight: "bold" }}
                  >
                    {slide.buttonText}
                  </Button>
                </motion.div>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>

      {/* Product Details Section */}
      <FeatureProduct data={friedFreshOnion} title={"Fried Fresh Onions"} />
            <FeatureProduct data={friedCoatedWhiteOnion} title={"Fried Coated white Onions"} />

      <FeatureProduct data={friedCoatedPinkOnion} title={"Fried Coated Pink Onions"} />

      <FeatureProduct data={friedWhiteOnionFlake} title={"Fried Coated white Onion Flakes"} />

      <FeatureProduct data={friedPinkOnionFlake} title={"Fried Coated Pink Onion Flakes"} />

    

      <Commonredirects />
    </>
  );
};

export default DetailedFriedOnions;
